import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class RecurringPurchaseSample extends Component {
    getOrderId() {
        const { progLangId } = this.props;
        switch(progLangId) {
            case _DOTNET:
                return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
            case _JAVA:
                return `"Test"+createDate.getTime()`;
            case _PHP:
                return `'ord-'.date("dmy-G:i:s")`;
            default:
                return "";
        }
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;
         return (
            <pre className="sampleCode">
{`using System;
using System.Collections;
public class TestCanadaPurchaseRecur
{ 
public static void Main(string[] args)
{   
string store_id = "`}{this.getValue(storeId, "storeId")}{`";
string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
string order_id = ${this.getOrderId()};
string amount = "`}{this.getValue(amount, "amount")}{`";
string pan = "`}{this.getValue(pan, "pan")}{`";
string expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
string crypt = "7";
/************************* Recur Variables **********************************/
string recur_unit = "month"; //eom = end of month
string start_now = "true";
string start_date = "2016/07/28";
string num_recurs = "12";
string period = "1";
string recur_amount = "30.00";
string processing_country_code = "CA";
bool status_check = false;
/************************* Recur Object Option1 ******************************/
Recur recurring_cycle = new Recur(recur_unit, start_now, start_date,
num_recurs, period, recur_amount);
/************************* Recur Object Option2 ******************************/
Hashtable recur_hash = new Hashtable();
recur_hash.Add("recur_unit", recur_unit);
recur_hash.Add("start_now", start_now);
recur_hash.Add("start_date", start_date);
recur_hash.Add("num_recurs", num_recurs);
recur_hash.Add("period", period);
recur_hash.Add("recur_amount", recur_amount);
Recur recurring_cycle2 = new Recur(recur_hash);
/************************ Transactional Object *******************************/
Purchase purchase = new Purchase(order_id, amount, pan, expiry_date, crypt);
/******************************* Set Recur ***********************************/
purchase.SetRecur(recurring_cycle);
CofInfo cof = new CofInfo();
cof.SetPaymentIndicator("R");
cof.SetPaymentInformation("2");
cof.SetIssuerId("168451306048014");
purchase.SetCofInfo(cof);
/**************************** Https Post Request ***************************/
HttpsPostRequest mpgReq = new HttpsPostRequest();
mpgReq.SetProcCountryCode(processing_country_code);
mpgReq.SetTestMode(true); //false or comment out this line for production transactions
mpgReq.SetStoreId(store_id);
mpgReq.SetApiToken(api_token);
mpgReq.SetTransaction(purchase);
mpgReq.SetStatusCheck(status_check);
mpgReq.Send();
/******************************* Receipt ***********************************/
try
{ Receipt receipt =
mpgReq.GetReceipt();
Console.WriteLine("CardType = " + receipt.GetCardType());
Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
Console.WriteLine("TransType = " + receipt.GetTransType());
Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
Console.WriteLine("ISO = " + receipt.GetISO());
Console.WriteLine("BankTotals = " + receipt.GetBankTotals());
Console.WriteLine("Message = " + receipt.GetMessage());
Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
Console.WriteLine("Complete = " + receipt.GetComplete());
Console.WriteLine("TransDate = " + receipt.GetTransDate());
Console.WriteLine("TransTime = " + receipt.GetTransTime());
Console.WriteLine("Ticket = " + receipt.GetTicket());
Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
Console.WriteLine("Recur Success = " + receipt.GetRecurSuccess());
Console.WriteLine("IsVisaDebit = " + receipt.GetIsVisaDebit());
Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
Console.ReadLine();
} 
catch (Exception e)
{ 
Console.WriteLine(e);
}
}
}
}
`}
            </pre>
        )
    }

  
   

    renderJAVA() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;
        return (
            <pre className="sampleCode">
{`public class TestCanadaPurchaseRecur
{ 
public static void main(String[] args)
{
String store_id = "`}{this.getValue(storeId, "storeId")}{`";
String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
java.util.Date createDate = new java.util.Date();
String order_id = ${this.getOrderId()};
String amount = "`}{this.getValue(amount, "amount")}{`";
String pan = "`}{this.getValue(pan, "pan")}{`";
String expiry_date =  "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
String crypt = "7";
/************************* Recur Variables **********************************/
String recur_unit = "month"; //eom = end of month
String start_now = "true";
String start_date = "2018/04/01";
String num_recurs = "12";
String period = "1";
String recur_amount = "30.00";
String processing_country_code = "CA";
boolean status_check = false;
/************************* Recur Object Option1 ******************************/
Recur recurring_cycle = new Recur(recur_unit, start_now, start_date,
num_recurs, period, recur_amount);
/************************* Recur Object Option2 ******************************/
Hashtable<String, String> recur_hash = new Hashtable<String, String>();
recur_hash.put("recur_unit", recur_unit);
recur_hash.put("start_now", start_now);
recur_hash.put("start_date", start_date);
recur_hash.put("num_recurs", num_recurs);
recur_hash.put("period", period);
recur_hash.put("recur_amount", recur_amount);
/************************ Transactional Object *******************************/
Purchase purchase = new Purchase();
purchase.setOrderId(order_id);
purchase.setAmount(amount);
purchase.setPan(pan);
purchase.setExpdate(expiry_date);
purchase.setCryptType(crypt);
/******************************* Set Recur ***********************************/
purchase.setRecur(recurring_cycle);
//Mandatory on Recurs - Credential on File details
CofInfo cof = new CofInfo();
cof.setPaymentIndicator("R");
cof.setPaymentInformation("2");
cof.setIssuerId("139X3130ASCXAS9");
purchase.setCofInfo(cof);
/**************************** Https Post Request ***************************/
HttpsPostRequest mpgReq = new HttpsPostRequest();
mpgReq.setProcCountryCode(processing_country_code);
mpgReq.setTestMode(true); //false or comment out this line for production transactions
mpgReq.setStoreId(store_id);
mpgReq.setApiToken(api_token);
mpgReq.setTransaction(purchase);
mpgReq.setStatusCheck(status_check);
mpgReq.send();
/******************************* Receipt ***********************************/
try
{ Receipt receipt =
mpgReq.getReceipt();
System.out.println("CardType = " + receipt.getCardType());
System.out.println("TransAmount = " + receipt.getTransAmount());
System.out.println("TxnNumber = " + receipt.getTxnNumber());
System.out.println("ReceiptId = " + receipt.getReceiptId());
System.out.println("TransType = " + receipt.getTransType());
System.out.println("ReferenceNum = " + receipt.getReferenceNum());
System.out.println("ResponseCode = " + receipt.getResponseCode());
System.out.println("ISO = " + receipt.getISO());
System.out.println("BankTotals = " + receipt.getBankTotals());
System.out.println("Message = " + receipt.getMessage());
System.out.println("AuthCode = " + receipt.getAuthCode());
System.out.println("Complete = " + receipt.getComplete());
System.out.println("TransDate = " + receipt.getTransDate());
System.out.println("TransTime = " + receipt.getTransTime());
System.out.println("Ticket = " + receipt.getTicket());
System.out.println("TimedOut = " + receipt.getTimedOut());
System.out.println("Recur Success = " + receipt.getRecurSuccess());
System.out.println("IsVisaDebit = " + receipt.getIsVisaDebit());
System.out.println("IssuerId = " + receipt.getIssuerId());
} 
catch (Exception e)
{ 
e.printStackTrace();
}
}
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;

        return (
            <pre className="sampleCode">
{`<?php
##
## Example php -q TestPurchase-Recur.php store3 yesguy unique_order_id
##
require "../../mpgClasses.php";
/**************************** Request Variables *******************************/
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
/********************************* Recur Variables ****************************/
$recurUnit = 'eom';
$startDate = '2018/11/30';
$numRecurs = '4';
$recurInterval = '10';
$recurAmount = '31.00';
$startNow = 'true';
/************************* Transactional Variables ****************************/
$orderId = 'ord-'.date("dmy-G:i:s");
$custId = 'student_number';
$creditCard = '5454545454545454';
$nowAmount = '`}{this.getValue(amount, "amount")}{`';
$expiryDate = '`}{this.getValue(expdate, "expdate")}{`';
$cryptType = '7';
/*********************** Recur Associative Array **********************/
$recurArray = array('recur_unit'=>$recurUnit, // (day | week | month)
'start_date'=>$startDate, //yyyy/mm/dd
'num_recurs'=>$numRecurs,
'start_now'=>$startNow,
'period' => $recurInterval,
'recur_amount'=> $recurAmount
);
$mpgRecur = new mpgRecur($recurArray);
/*********************** Transactional Associative Array **********************/
$txnArray=array('type'=>'purchase',
'order_id'=>$orderId,
'cust_id'=>$custId,
'amount'=>$nowAmount,
'pan'=>`}{this.getValue(pan, "pan")}{`,
'expdate'=>$expiryDate,
'crypt_type'=>$cryptType
);
/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($txnArray);
/****************************** Recur Object *********************************/
$mpgTxn->setRecur($mpgRecur);
/******************* Credential on File **********************************/
$cof = new CofInfo();
$cof->setPaymentIndicator("R");
$cof->setPaymentInformation("2");
$cof->setIssuerId("168451306048014");
$mpgTxn->setCofInfo($cof);
/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions
/***************************** HTTPS Post Object *****************************/
$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);
/******************************* Response ************************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print ("\nCardType = " . $mpgResponse->getCardType());
print("\nTransAmount = " . $mpgResponse->getTransAmount());
print("\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\nReceiptId = " . $mpgResponse->getReceiptId());
print("\nTransType = " . $mpgResponse->getTransType());
print("\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\nResponseCode = " . $mpgResponse->getResponseCode());
print("\nISO = " . $mpgResponse->getISO());
print("\nMessage = " . $mpgResponse->getMessage());
print("\nIsVisaDebit = " . $mpgResponse->getIsVisaDebit());
print("\nAuthCode = " . $mpgResponse->getAuthCode());
print("\nComplete = " . $mpgResponse->getComplete());
print("\nTransDate = " . $mpgResponse->getTransDate());
print("\nTransTime = " . $mpgResponse->getTransTime());
print("\nTicket = " . $mpgResponse->getTicket());
print("\nTimedOut = " . $mpgResponse->getTimedOut());
print("\nRecurSuccess = " . $mpgResponse->getRecurSuccess());
print("\nIssuerId = " . $mpgResponse->getIssuerId());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, onEditId } = state.recurring.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, orderId, pan, expdate, amount, currency, progLangId: selection, onEditId };
  }
  
  export default connect(mapStateToProps, {})(RecurringPurchaseSample)